<template>
  <component :is="layout" v-if="loginCompleted">
    <router-view/>
  </component>
  <PopupRegistration/>
  <Teleport to="body">
    <KazPush
      v-if="showPush"
      class="kaz-push-container"
      type="Подарок для тебя"
      title="Подключим тебе тариф бесплатно"
      icon="kuiIconGiftLarge"
      description="Зарегистрируйся и получи доступ к тысячам решений прямо сейчас!"
      primaryActionLabel="Зарегистрироваться"
      secondaryActionLabel="Уже есть аккаунт"
      @close="closePush"
      @primary-action="regPush"
      @secondary-action="closePush"
    />
  </Teleport>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import MainLayout from '@/layouts/MainLayout.vue';
import LandingLayout from '@/layouts/LandingLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import ProfileLayout from '@/layouts/ProfileLayout.vue';
import TasksLayout from '@/layouts/TasksLayout.vue';
import MonetizationLayout from '@/layouts/MonetizationLayout.vue';
import ModerationLayout from '@/layouts/ModerationLayout.vue';
import GPTLayout from '@/layouts/GPTLayout.vue'
import DocsLayout from '@/layouts/DocsLayout.vue'
import PopupRegistration from '@/components/UI/popups/PopupRegistration.vue';
import KazPush from '@/components/KazUI/molecules/push';

import useUnregPush from '@/hooks/push/useUnregPush';


export default {
  setup() {
    const {
      show: showPush,
      close: closePush,
      reg: regPush,
      start: startPushing,
    } = useUnregPush(15000, 15000);
    return {
      showPush,
      startPushing,
      closePush,
      regPush,
    }
  },

  data() {
    return {
      stylesLoaded: false,
      loginCompleted: false,
    };
  },

  components: {
    MainLayout,
    AuthLayout,
    LandingLayout,
    ProfileLayout,
    TasksLayout,
    MonetizationLayout,
    PopupRegistration,
    ModerationLayout,
    GPTLayout,
    DocsLayout,
    KazPush,
  },

  computed: {
    ...mapGetters({
      sessionActive: 'authData/sessionActive',
    }),

    layout() {
      // this available only after mounted hook - this is bug source
      // return (this.$route.meta.layout || 'landing') + '-layout'
      let layout = this.$route.meta.layout;
      if (layout === 'tasks' || layout === 'profile') {
        layout = 'main';
      }
      return (layout || 'landing') + '-layout'
    }
  },

  methods: {
    ...mapActions({
      initLogin: 'authData/initLogin',
      fetchCoursesMapping: 'coursesMapping/fetchMapping',
    }),
    async loadStyles() {
      await import('bootstrap/dist/css/bootstrap.min.css');
      await import('@/assets/reset.css');
      await import('@/assets/style.css');
      await import('@/assets/variables.css');
      this.stylesLoaded = true;
    }
  },

  async created() {
    this.loadStyles();
    try {
      await this.initLogin();
      this.startPushing(!this.sessionActive);
    } catch (error) {
      console.warn(error);
      this.$router.push({ name: 'login' });
    }
    try {
      await this.fetchCoursesMapping();
    } catch (error) {
      console.error('LOADING [COURSE-MAPPING]:', error);
    }
    this.loginCompleted = true;
  }
}
</script>

<style lang="scss" scoped>
.kaz-push-container {
  position: fixed;
  bottom: 26px;
  right: 72px;
}

@media screen and (max-width: 992px) {
  .kaz-push-container {
    position: fixed;
    bottom: 32px;
    right: 12px;
  }
}
</style>
